module.exports = __webpack_public_path__ + "img/HTML.9cf4a14c.png";